import React, { useCallback } from 'react';
import { observer } from 'mobx-react-lite';
import { PreviewVintageModelInstance } from '../../../store/_models/previewVintage';
import { UserText } from './UserText';
import { UserTextModelInstance } from '../../../store/_models/userText';

export type PreviewTextsProps = {
  preview: PreviewVintageModelInstance;
  userTexts: UserTextModelInstance[];
};

export const PreviewTexts = observer(({ preview, userTexts }: PreviewTextsProps) => {
  // Check if preview has userTextAreas (only PreviewVintageModel has this property)
  const userTextAreas = preview.userTextAreas ?? [];

  const userTextById = useCallback(
    (userTextAreaId: string) => {
      return userTexts.find(ut => ut.id === userTextAreaId);
    },
    [userTexts],
  );

  return (
    <>
      {userTextAreas.map(userTextArea => {
        const userText = userTextById(userTextArea.id);

        // Skip if no userText found for this textArea
        if (!userText) return null;

        return <UserText key={userTextArea.id} userText={userText} textArea={userTextArea} />;
      })}
    </>
  );
});
